"use client";
import * as React from "react";

interface EBProps {
    children?: React.ReactNode;
    fallback?: React.ReactNode;
}

interface EBState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<EBProps, EBState> {
    public state: EBState = {
        hasError: false
    };

    constructor(props: EBProps) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError(): EBState {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <p>OOPS! There was an error</p>;
        }

        return this.props.children;
    }
}
